import { MouseEvent, useState } from "react";
import useEvent from "react-use-event-hook";

import type { TAuditLogExportScope } from "@ryde/shared";

/** Open state of the export menu, and picking what to export closes it. */
export const useSearchSectionExport = (
  onExport: (scope: TAuditLogExportScope) => void,
) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);

  const onOpen = useEvent((event: MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  });
  const onClose = useEvent(() => setAnchorElement(null));
  const onSelect = useEvent((scope: TAuditLogExportScope) => {
    setAnchorElement(null);
    onExport(scope);
  });

  return { anchorElement, isOpen: !!anchorElement, onOpen, onClose, onSelect };
};
